import React from 'react';

const RiskAnalyzerInfo = ({hideRiskAnalyzerInfo}) => {

  return (
    <div className="risk-classification-container hidePopup" onClick={hideRiskAnalyzerInfo} id="RiskAnalyzerInfo">
      <div className="risk-classification-content">
        <p>Input key details about a client to predict their risk category — low, medium, or high — based on historical patterns.</p>
      </div>
    </div>
  )
}

export default RiskAnalyzerInfo;